import Basic from './Basic';
import Background from './Background';
import Avatar from './Avatar';

export const Image = Basic;
export const BackgroundImage = Background;
export const AvatarImage = Avatar;
